import { loaderAction, paymentMethodsFormAction, typeOpenSettingsFormAction } from "../rootReducer";
import { api } from "../../helpers/api";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionDataSagaAction } from "../sagaActions";
import { PAYMENT_METHODS_FORM_INITIAL } from "../initialStateConstant";

export const updatePaymentMethodThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('payment_methods_id', args.payment_methods_id || '');
        formData.append('name', args.name);
        formData.append('establishments', args.establishments);
        formData.append('active', args.active);
        formData.append('online', args.online);
        formData.append('deposit', args.deposit);
        formData.append('debt', args.debt);

        const response = await api({ data: formData, link: 'update_payment_methods' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список методов оплаты
            dispatch(getSubscriptionDataSagaAction());
            // Очищаем форму метода оплаты
            dispatch(paymentMethodsFormAction(PAYMENT_METHODS_FORM_INITIAL));
            // Закрываем форму
            dispatch(typeOpenSettingsFormAction(''));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};